import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Tooltip} from '@mui/material';
import React from 'react';

interface HelpTooltipProps {
  children: React.ReactNode;
  direction?: 'top' | 'bottom' | 'left' | 'right';
}

const HelpTooltip: React.FC<HelpTooltipProps> = ({
  children,
  direction = 'right',
}) => {
  return (
    <Tooltip arrow placement={direction} title={children}>
      <InfoOutlinedIcon
        sx={{
          width: 20,
          height: 20,
          color: 'action.active',
          '&:hover': {
            color: 'text.primary',
          },
        }}
      />
    </Tooltip>
  );
};

export default HelpTooltip;
